import React, { createContext, useContext, ReactNode } from "react";
import { useCountdown } from "../hooks/useCountdown";
import { useStock } from "../hooks/useStock";
import { useVisitorLocale } from "../hooks/useVisitorLocale";
const TOTAL_SLOTS = 300;
type OfferState = {
  minutes: string;
  seconds: string;
  expired: boolean;
  stock: number;
  soldPercent: number;
  dateLabel: string;
  shortDate: string;
  city: string | null;
};
const OfferContext = createContext<OfferState | null>(null);
export function OfferProvider({
  children
}: {
  children: ReactNode;
}) {
  const secondsLeft = useCountdown();
  const stock = useStock(47, 2);
  const {
    dateLabel,
    shortDate,
    city
  } = useVisitorLocale();
  const value: OfferState = {
    minutes: String(Math.floor(secondsLeft / 60)).padStart(2, "0"),
    seconds: String(secondsLeft % 60).padStart(2, "0"),
    expired: secondsLeft === 0,
    stock,
    soldPercent: Math.round((TOTAL_SLOTS - stock) / TOTAL_SLOTS * 100),
    dateLabel,
    shortDate,
    city
  };
  return <OfferContext.Provider value={value} data-id="element-624" data-mp="1jktwyplgeycz">{children}</OfferContext.Provider>;
}
export function useOffer() {
  const ctx = useContext(OfferContext);
  if (!ctx) throw new Error("useOffer must be used inside OfferProvider");
  return ctx;
}